import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from 'primeng/tooltip';
import { USER_TYPE } from '../../../../../@core/models/enums';
import { SOCKET_EVENTS, SocketService } from '../../../../../@core/services/socket.service';
import { ToastService } from '../../../../../@core/services/toast.service';
import { AUDIT_MODULE, AuditLogService, IAuditLog } from '../../../../../contract-management/services/audit-log.service';
import { TruncatePipe } from "../../../../pipes/truncate.pipe";
import { DateFormatterPipe } from '../../../../pipes/dateFormater.pipe';
import { CheckScreenSize } from '../../../../../services/check-screen-size.service';
import { DEACTIVATION_STATUS } from 'src/app/@core/models/model';
import { UserNameDisplayComponent } from 'src/app/@shared/components/user-name-display';
import { SVG } from 'src/app/common/svgs';
import { SanitizeHtmlPipe } from 'src/app/@shared/pipes/sanitizeHtml.pipe';

@Component({
  selector: 'app-history-tab',
  imports: [
    CommonModule,
    TimelineModule,
    TooltipModule,
    TruncatePipe,
    DateFormatterPipe,
    UserNameDisplayComponent,
    SanitizeHtmlPipe
  ],
  standalone: true,
  templateUrl: './history-tab.component.html',
  styleUrl: './history-tab.component.scss'
})
export class HistoryTabComponent implements OnInit {
  @Input({ required: true }) auditModule!: AUDIT_MODULE;
  @Input() filter: Record<string, string> = {};
  history: IAuditLog[] = [];
  USER_TYPE = USER_TYPE
  isSmallScreen: boolean = false
  DEACTIVATION_STATUS = DEACTIVATION_STATUS;
  SVG = SVG

  constructor(private auditLogService: AuditLogService, private checkScreenSizeService: CheckScreenSize, private toast: ToastService, private socketService: SocketService) {
    this.socketService.on<{ auditLog: IAuditLog }>(SOCKET_EVENTS.AUDIT_LOG_CREATED).subscribe((res) => {
      const auditLog = res[0].auditLog as IAuditLog;

      if (this.auditModule === auditLog.module) {
        let shouldAdd = false;

        switch (auditLog.module) {
          case AUDIT_MODULE.COMPARE: {
            const { compareId, kpiId } = auditLog.data;
            if (compareId && this.filter['compareId'] === compareId) {
              shouldAdd = !kpiId || this.filter['kpiId'] === kpiId;
            }
            break;
          }
          case AUDIT_MODULE.DOCUMENT: {
            const { documentId } = auditLog.data;
            if (documentId && this.filter['documentId'] === documentId) {
              shouldAdd = true;
            }
            break;
          }
          case AUDIT_MODULE.PROJECTS: {
            const { projectId } = auditLog.data;
            if (projectId && this.filter['projectId'] === projectId.toString()) {
              shouldAdd = true;
            }
            break;
          }
          case AUDIT_MODULE.DOCUMENT_FORM: {
            const { contractId } = auditLog.data;
            if (contractId && this.filter['contractId'] === contractId) {
              shouldAdd = true;
            }
            break;
          }
        }

        if (shouldAdd) {
          this.history = [...this.history, auditLog];
        }
      }
    });
  }

  ngOnInit(): void {
    this.isSmallScreen = this.checkScreenSizeService.checkScreenSize()
    this.auditLogService.getAuditLogs(this.auditModule, this.filter).subscribe((res) => {
      if (res && res.success) {
        this.history = res.data || [];
      } else {
        this.toast.error(res.message);
      }
    });
  }

  isUserUnverified(item: any): boolean {
    return item && item.user && typeof item.user !== 'string' && item.user.verified === false;
  }
}
